<template>
  <div class="ProductExtras">
    <div v-for="extra in extras" :key="extra.CODMODIFICADOR">
      <div class="ProductExtras__title">
        {{extra.DESCRIPCION}}
        <small>({{selecteds.length}} de {{extra.LIMITE}})</small>
      </div>
      <div class="ProductExtras__options">
        <div class="ProductExtras__options__option"
             :class="{'selected': isOptionSelected(option)}"
             :style="extraStyle(option)"
             v-for="option in extra.OPCIONES"
             :key="option.CODARTICULO"
             @click="onSelectOption(option, extra)">
          <div class="ProductExtras__options__option__description">{{option.DESCRIPCION}}</div>
          <span class="badge badge-warning ProductExtras__options__option__price" v-if="showInc(option)"
          >{{incPrecio(option)}}</span>
          <span class="badge badge-success ProductExtras__options__option__selected" v-if="isOptionSelected(option)"
          ><i class="fa fa-check" /></span>
        </div>
      </div>
    </div>
    <div class="extras__popup" v-if="extrasPopup">
      <div class="extras__popup__content">
        <OrderAddProductExtras
            :product="extrasProduct"
            :formats="extrasFormats"
            :modificadores="extrasExtras"
            @addProduct="onAddOptionExtras"
        />
      </div>
    </div>
  </div>
</template>
<script>
import OrderAddProductExtras from '../Order/OrderAddProductExtras'

export default {
  components: { OrderAddProductExtras },
  props: {
    extras: { required: true }
  },
  data() {
    return {
      selecteds: [],
      extrasPopup: false,
      extrasProduct: {},
      extrasFormats: [],
      extrasExtra: {},
      extrasExtras: []
    }
  },
  methods: {
    isOptionSelected(option) {
      const count = this.selecteds.filter(
        o => o.CODARTICULO === option.CODARTICULO
      ).length
      return count > 0
    },
    onSelectOption(option, extra) {
      if (!this.isOptionSelected(option)) {
        if (extra.LIMITE - this.selecteds.length > 0) {
          if (option.MODIFICADORES && option.MODIFICADORES.length > 0) {
            const product = this.$store.state.catalog_products.find(
              p => p.CODARTICULO === option.CODARTICULO
            )
            const catalog_modificadores = this.$store.getters
              .catalog_modificadores
            // FORMATOS
            this.extraFormats = []
            if (product.FORMATOS)
              product.FORMATOS.forEach(f => {
                const formato = this.$store.state.catalog.FORMATOS.find(
                  cf => cf.CODMODIFICADOR === f
                )
                this.extraFormats.push(formato)
              })
            // MODIFICADORES
            this.extrasExtras = []
            if (product.MODIFICADORES)
              product.MODIFICADORES.forEach(m => {
                const modificador = Object.assign(
                  {},
                  catalog_modificadores.find(cm => cm.CODMODIFICADOR === m)
                )
                modificador.CODOPCIONES = modificador.OPCIONES
                modificador.OPCIONES = []
                modificador.CODOPCIONES.forEach(o => {
                  const opcion = this.$store.getters.catalog_opciones.find(
                    co => co.CODARTICULO === o
                  )
                  const articulo = this.$store.state.catalog_products.find(
                    p => p.CODARTICULO === o
                  )
                  const opcionArticulo = Object.assign({}, articulo, opcion)
                  modificador.OPCIONES.push(opcionArticulo)
                })
                this.extrasExtra = extra
                this.extrasProduct = product
                this.extrasExtras.push(modificador)
              })
            this.extrasPopup = true
          } else {
            this.onAddOption(option, extra)
          }
        } else {
          alert(`LIMITE DE EXTRAS ES DE ${extra.LIMITE}`)
        }
      } else {
        this.onDeleteOption(option, extra)
      }
    },
    onAddOption(option, extra) {
      this.selecteds.push(option)
      this.$emit('optionSelected', {
        extra: extra,
        extras: this.selecteds
      })
    },
    onAddOptionExtras(extras) {
      this.onAddOption(extras, this.extrasExtra)
      this.extrasProduct = {}
      this.extrasFormats = []
      this.extrasExtra = {}
      this.extrasExtras = []
      this.extrasPopup = false
    },
    onDeleteOption(option, extra) {
      this.selecteds = this.selecteds.filter(
        o => o.CODARTICULO !== option.CODARTICULO
      )
      this.$emit('optionDeleted', {
        extra: extra,
        extras: this.selecteds
      })
    },
    showInc(option) {
      const inc = Number(option.INCPRECIO)
      return inc !== 0
    },
    incPrecio(option) {
      let inc = Number(option.INCPRECIO)
      let sim = inc > 0 ? '+' : '-'
      return `${sim}${inc.toFixed(2)}€`
    },
    extraStyle(option) {
      const colorFondo = '#' + this.getColor(Number(option.COLORFONDO))
      const colorTexto = '#' + this.getColor(Number(option.COLORTEXTO))

      if (colorFondo === '#000000' && colorTexto === '#000000') return

      return {
        backgroundColor: colorFondo,
        color: colorTexto
      }
    },
    getColor: int => {
      let red = int >> 16
      let green = (int - (red << 16)) >> 8
      let blue = int - (red << 16) - (green << 8)
      let bin = (blue << 16) | (green << 8) | red
      return (function(h) {
        return new Array(7 - h.length).join('0') + h
      })(bin.toString(16).toUpperCase())
    }
  }
}
</script>
<style lang="scss">
.ProductExtras {
  margin-bottom: 2rem;

  &__title {
    font-weight: bold;
    margin-bottom: 1rem;
    font-size: 0.92rem;
  }

  &__options {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 0.4rem;
    grid-auto-rows: minmax(5rem, 1fr);

    &__option {
      align-items: flex-end;
      background-color: white;
      border: 0.2rem solid transparent;
      border-radius: 0.4rem;
      display: flex;
      justify-content: center;
      user-select: none !important;
      padding: 0.4rem;
      text-align: center;
      position: relative;

      &.selected {
        border: 0.2rem solid #309930;

        .badge {
          font-weight: bold;
        }
      }

      &__description {
        font-size: 0.8rem;
        font-weight: bold;
        text-transform: uppercase;
      }

      &__price {
        position: absolute;
        top: 0.25rem;
        right: 0.25rem;
        font-weight: normal;
      }

      &__selected {
        position: absolute;
        top: 0.25rem;
        left: 0.25rem;
        font-weight: normal;
      }
    }
  }

  .option-selected {
    border: 0.1em solid #309930;
    align-items: center;
    background-color: white;
    border-radius: 0.32rem;
    padding: 0.4rem;
    display: flex;
    font-weight: bold;
    margin-bottom: 0.4rem;

    &__details {
      flex: 1;
    }
  }
}
</style>